import Tile from '@uilib/business-components/Tile';

import i18n from 'Services/i18n';

export default function TileWrapper(props) {
    return <Tile {...props} title={i18n(props.title)} subtitle={i18n(props.subtitle)} />;
}
